import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=7292239c&scoped=true&"
import script from "./Reviews.vue?vue&type=script&lang=ts&"
export * from "./Reviews.vue?vue&type=script&lang=ts&"
import style0 from "./Reviews.vue?vue&type=style&index=0&id=7292239c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7292239c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Review: require('/opt/build/repo/apps/shop/components/Review.vue').default})
